// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const AstronautSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'astronaut-walk',
    metadata: {
      frames: {
        'astronaut-walk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-bottom-7': {
          frame: {
            x: 224,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-0': {
          frame: {
            x: 0,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-1': {
          frame: {
            x: 32,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-2': {
          frame: {
            x: 64,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-3': {
          frame: {
            x: 96,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-4': {
          frame: {
            x: 128,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-5': {
          frame: {
            x: 160,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-6': {
          frame: {
            x: 192,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-left-7': {
          frame: {
            x: 224,
            y: 32,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-0': {
          frame: {
            x: 0,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-1': {
          frame: {
            x: 32,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-2': {
          frame: {
            x: 64,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-3': {
          frame: {
            x: 96,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-4': {
          frame: {
            x: 128,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-5': {
          frame: {
            x: 160,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-6': {
          frame: {
            x: 192,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'astronaut-walk-top-7': {
          frame: {
            x: 224,
            y: 64,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/astronaut/walk.png',
        size: {
          w: 256,
          h: 96,
        },
        scale: '1',
      },
      animations: {
        'astronaut-walk-bottom': [
          'astronaut-walk-bottom-0',
          'astronaut-walk-bottom-1',
          'astronaut-walk-bottom-2',
          'astronaut-walk-bottom-3',
          'astronaut-walk-bottom-4',
          'astronaut-walk-bottom-5',
          'astronaut-walk-bottom-6',
          'astronaut-walk-bottom-7',
        ],
        'astronaut-walk-left': [
          'astronaut-walk-left-0',
          'astronaut-walk-left-1',
          'astronaut-walk-left-2',
          'astronaut-walk-left-3',
          'astronaut-walk-left-4',
          'astronaut-walk-left-5',
          'astronaut-walk-left-6',
          'astronaut-walk-left-7',
        ],
        'astronaut-walk-top': [
          'astronaut-walk-top-0',
          'astronaut-walk-top-1',
          'astronaut-walk-top-2',
          'astronaut-walk-top-3',
          'astronaut-walk-top-4',
          'astronaut-walk-top-5',
          'astronaut-walk-top-6',
          'astronaut-walk-top-7',
        ],
        'astronaut-walk-bottom-left': [
          'astronaut-walk-left-0',
          'astronaut-walk-left-1',
          'astronaut-walk-left-2',
          'astronaut-walk-left-3',
          'astronaut-walk-left-4',
          'astronaut-walk-left-5',
          'astronaut-walk-left-6',
          'astronaut-walk-left-7',
        ],
        'astronaut-walk-top-left': [
          'astronaut-walk-left-0',
          'astronaut-walk-left-1',
          'astronaut-walk-left-2',
          'astronaut-walk-left-3',
          'astronaut-walk-left-4',
          'astronaut-walk-left-5',
          'astronaut-walk-left-6',
          'astronaut-walk-left-7',
        ],
      },
    },
  },
];
